import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Form, Pagination, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
export default function BasicTable({
  data,
  columns,
  title,
  actionButton,
  footer,
}) {
  const { t } = useTranslation();
  const [sorting, setSorting] = useState([]);
  const [filtering, setFiltering] = useState("");
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting: sorting,
      globalFilter: filtering,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  return (
    <Container fluid>
      <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
        <div className="d-flex align-items-center justify-content-between">
          <h6 className="font-weight-bold">{t(title)}</h6>
        </div>
        <div className="create-workform">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <div className="modal-product-search d-flex">
              <Form className="mr-3 position-relative">
                <div className="form-group mb-0">
                  <Form.Control
                    type="text"
                    className="form-control"
                    value={filtering}
                    id="exampleInputText"
                    onChange={(e) => setFiltering(e.target.value)}
                    placeholder="Search ..."
                  />
                  <Link className="search-link" to="#">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className=""
                      width="20"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </Link>
                </div>
              </Form>

              <div className=" position-relative d-flex align-items-center justify-content-between">
                {actionButton}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table data-table mb-0">
          <thead className="table-color-heading">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr className="text-light" key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {header.isPlaceholder ? null : (
                      <div className="text-muted mb-0">
                        {flexRender(
                          t(header.column.columnDef.header),
                          header.getContext()
                        )}
                        {
                          { asc: "🔼", desc: "🔽" }[
                            header.column.getIsSorted() ?? null
                          ]
                        }
                      </div>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className="white-space-no-wrap">
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
          <tfoot>{footer}</tfoot>
        </table>
        <Pagination className="justify-content-end">
          <Pagination.First onClick={() => table.setPageIndex(0)} />
          <Pagination.Prev
            disabled={!table.getCanPreviousPage()}
            onClick={() => table.previousPage()}
          />
          <Pagination.Item>
            {table.getState().pagination.pageIndex + 1} of{" "}
            {table.getPageCount()}
          </Pagination.Item>
          <Pagination.Next
            disabled={!table.getCanNextPage()}
            onClick={() => table.nextPage()}
          />
          <Pagination.Last
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          />
        </Pagination>
      </div>
    </Container>
  );
}
